var map = {
	"./commontest.js": "gSQy",
	"./dictionary.js": "1L+U",
	"./promise.js": "K3ub"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VUEg";


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/common/modules nonrecursive \.js$
// module id = VUEg
// module chunks = 1